var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8TiquetteDePrix2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 28 4 C 26.408649 4 24.883169 4.6324568 23.757812 5.7578125 L 5.7578125 23.757812 C 3.4278601 26.087765 3.4278601 29.912235 5.7578125 32.242188 L 15.757812 42.242188 C 16.883169 43.367542 18.408649 44 20 44 C 21.591351 44 23.116831 43.367543 24.242188 42.242188 L 42.242188 24.242188 C 43.367959 23.116416 44 21.589398 44 19.998047 L 44 9 C 44 6.2565285 41.743472 4 39 4 L 28 4 z M 28 7 L 39 7 C 40.116528 7 41 7.8834715 41 9 L 41 19.998047 C 41 20.810696 40.695322 21.546865 40.121094 22.121094 L 22.121094 40.121094 C 21.546449 40.695738 20.812649 41 20 41 C 19.187351 41 18.453551 40.695738 17.878906 40.121094 L 7.8789062 30.121094 C 6.6988587 28.941046 6.6988586 27.058954 7.8789062 25.878906 L 25.878906 7.8789062 C 26.453551 7.3042619 27.187351 7 28 7 z M 34 11 C 32.343 11 31 12.343 31 14 C 31 15.657 32.343 17 34 17 C 35.657 17 37 15.657 37 14 C 37 12.343 35.657 11 34 11 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8TiquetteDePrix2);
export default __webpack_public_path__ + "static/media/icons8-étiquette-de-prix (2).8c0ad400df9aa43dc609f017d98ffbf2.svg";
export { ForwardRef as ReactComponent };